import { useEffect } from 'react';
import SelectField from '../../../components/Forms/Input/SelectField';
import InputField from '../../../components/Forms/Input/InputField';
import { useSaleInvalidation } from '../../../hooks/sale/useSaleInvalidation';
import { useInvalidationType } from '../../../hooks/invalidationType/useInvalidationType';

const SaleCancelForm = () => {
  const {
    form,
    formErrors,
    updateField,
    setErrors,
    clearErrors,
    searchSaleToInvalidate,
    onChangeInvalidationType,
  } = useSaleInvalidation();

  const {
    invalidationTypeDropdown,
    fetchInvalidationTypeDropdown,
  } = useInvalidationType();

  useEffect(() => {
    fetchInvalidationTypeDropdown();
  }, []);

  const handleSearchSale = async () => {
    const code = form.generationCodeToInvalidate?.trim();
    if (!code) {
      setErrors({ generationCodeToInvalidate: 'Required' });
      return;
    }
    clearErrors();
    await searchSaleToInvalidate(code);
  };

  const generationCodeEmpty =
    !form.generationCodeToInvalidate || !form.generationCodeToInvalidate.trim();

  return (
    <div className="w-full space-y-6">
      <div className="grid w-full grid-cols-1 gap-5 sm:grid-cols-2">
        <SelectField
          label="Motivo de Anulación"
          name="invalidationTypeCode"
          iconKey="list"
          value={(form.invalidationTypeCode ?? '').toString()}
          onChange={(e) => onChangeInvalidationType(e.target.value)}
          options={invalidationTypeDropdown.map((item) => ({
            value: item.code,
            label: item.name,
          }))}
          placeholder="Seleccione el motivo"
          error={formErrors.invalidationTypeCode}
          required
        />

        <div className="sm:col-span-2">
          <InputField
            label="Código de Generación"
            name="generationCodeToInvalidate"
            value={form.generationCodeToInvalidate ?? ''}
            onChange={(e) =>
              updateField('generationCodeToInvalidate', e.target.value)
            }
            iconKey="hash"
            error={formErrors['generationCodeToInvalidate']}
            type="text"
            required
            placeholder="664F9D1B-70DA-427D-93B5-C3C7C4B4B9C7"
          />
        </div>
      </div>

      <div className="flex justify-end pt-6">
        <button
          type="button"
          onClick={handleSearchSale}
          disabled={generationCodeEmpty}
          className={`rounded px-4 py-2 font-semibold text-white ${
            generationCodeEmpty
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-primary hover:bg-opacity-90'
          }`}
        >
           Buscar Venta
        </button>
      </div>
    </div>
  );
};

export default SaleCancelForm;
